// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CreatePlanPackageMutationVariables = Types.Exact<{
  input: Types.SavePlanPackageInput;
}>;


export type CreatePlanPackageMutation = { __typename?: 'Mutation', savePlanPackage: { __typename?: 'SavePlanPackageResult', planPackage: { __typename?: 'PlanPackage', id: string, name: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } } } };


export const CreatePlanPackageDocument = gql`
    mutation CreatePlanPackage($input: SavePlanPackageInput!) {
  savePlanPackage(input: $input) {
    planPackage {
      ...Named
      version {
        id
      }
    }
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useCreatePlanPackageMutation__
 *
 * To run a mutation, you first call `useCreatePlanPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlanPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlanPackageMutation, { data, loading, error }] = useCreatePlanPackageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlanPackageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePlanPackageMutation, CreatePlanPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePlanPackageMutation, CreatePlanPackageMutationVariables>(CreatePlanPackageDocument, options);
      }
export type CreatePlanPackageMutationHookResult = ReturnType<typeof useCreatePlanPackageMutation>;
export type CreatePlanPackageMutationResult = ApolloReactCommon.MutationResult<CreatePlanPackageMutation>;